import { Button } from 'components/Button';
import ModalContainer from 'components/Modal/ModalContainer';
import styled from 'styled-components';
import { useState } from 'react';

const Input = styled.input`
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 24px;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const WatchlistModal = ({ isOpen, onClose, onConfirm }) => {
    const [name, setName] = useState('');

    const handleConfirm = () => {
        onConfirm(name || 'My Watchlist');
        onClose();
    };

    return (
        <ModalContainer
            isOpen={isOpen}
            onClose={onClose}
            title={'Create Watchlist'}
        >
            <Input
                type="text"
                placeholder='Name your watchlist (default: "My Watchlist")'
                value={name}
                onChange={(e) => setName(e.target.value)}
            />
            <ButtonContainer>
                <Button intent="primary" type="submit" onClick={handleConfirm}>
                    Create
                </Button>
            </ButtonContainer>
        </ModalContainer>
    );
};

export default WatchlistModal;
